import { useMutation } from '@tanstack/react-query';

import { type SingleTeamParams } from '@app/client/common/structs';
import { callLeaveTeam } from '@app/client/resources/competitions';

export function useLeaveTeam() {
    return useMutation({
        mutationFn: (teamId: SingleTeamParams) => callLeaveTeam(teamId),
    });
}
